var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMingcuteBuilding1Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing Page - Option2",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    transform: "translate(-599 -6800)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-601 -109C-601 -136.614 -578.614 -159 -551 -159H791C818.614 -159 841 -136.614 841 -109V518H-601V-109Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mingcute:building-1-line",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8674 2.58691C11.2892 2.58678 11.6955 2.74609 12.0047 3.0329C12.314 3.31971 12.5035 3.71283 12.5351 4.13345L12.5393 4.25884V7.6027H15.0472C15.469 7.60257 15.8753 7.76187 16.1846 8.04868C16.4939 8.33549 16.6833 8.72861 16.7149 9.14923L16.7191 9.27463V15.9623H17.5551C17.7682 15.9626 17.9731 16.0442 18.128 16.1904C18.283 16.3367 18.3762 16.5366 18.3887 16.7493C18.4012 16.962 18.332 17.1715 18.1952 17.3349C18.0585 17.4982 17.8645 17.6033 17.6529 17.6284L17.5551 17.6343H2.50774C2.29467 17.634 2.08973 17.5524 1.93479 17.4062C1.77986 17.2599 1.68662 17.06 1.67414 16.8473C1.66165 16.6346 1.73085 16.4251 1.86761 16.2618C2.00437 16.0984 2.19835 15.9934 2.40993 15.9682L2.50774 15.9623H3.3437V4.25884C3.34357 3.83703 3.50287 3.43076 3.78969 3.12147C4.0765 2.81218 4.46961 2.62273 4.89023 2.59109L5.01563 2.58691H10.8674ZM15.0472 9.27463H12.5393V15.9623H15.0472V9.27463ZM10.8674 4.25884H5.01563V15.9623H10.8674V4.25884ZM9.19545 12.6185V14.2904H6.68756V12.6185H9.19545ZM9.19545 9.27463V10.9466H6.68756V9.27463H9.19545ZM9.19545 5.93077V7.6027H6.68756V5.93077H9.19545Z",
    fill: "white"
  }))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -601,
    y1: -159,
    x2: 825.75,
    y2: 519.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED9232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814403"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    fill: "white",
    transform: "translate(-599 -6800)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0631,
    height: 20.0631,
    fill: "white",
    transform: "translate(0 0.0791016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteBuilding1Line);
export default __webpack_public_path__ + "static/media/mingcute_building-1-line.30766871e9a5d4720a7881ebe63b824c.svg";
export { ForwardRef as ReactComponent };